import { render, staticRenderFns } from "./SectionCategories.vue?vue&type=template&id=fb433502"
import script from "./SectionCategories.vue?vue&type=script&lang=js"
export * from "./SectionCategories.vue?vue&type=script&lang=js"
import style0 from "./SectionCategories.vue?vue&type=style&index=0&id=fb433502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports